import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { PAST_EDITIONS, getFullImageUrl } from '../../data/pastEditions';

/**
 * Public "Past Editions" page — replica of the legacy site list.
 * Cards link to internal detail pages /edizioni-precedenti/{slug}.
 */
export const PastEditionsPage = () => {
  useEffect(() => {
    document.title = 'Edizioni Precedenti — StartupItalia Open Summit';
  }, []);

  return (
    <div className="min-h-screen bg-sios-void text-white">
      <div className="max-w-7xl mx-auto px-4 py-12 sm:py-16">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary mb-6" data-testid="back-home-link">
          <ArrowLeft size={14} /> Home
        </Link>

        <div className="mb-12 text-center">
          <p className="text-sm tracking-widest text-primary uppercase mb-3">Scopri</p>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight">Tutte le edizioni di SIOS</h1>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="past-editions-grid">
          {PAST_EDITIONS.map((ed) => (
            <Link
              key={ed.slug}
              to={`/edizioni-precedenti/${ed.slug}`}
              className="group block rounded-2xl overflow-hidden border border-white/10 bg-white/5 hover:border-primary/50 transition-all"
              data-testid={`past-edition-${ed.slug}`}
            >
              <div className="aspect-[750/465] overflow-hidden bg-black/40">
                <img
                  src={getFullImageUrl(ed.image)}
                  alt={`${ed.name} ${ed.year}`}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <h2 className="font-heading text-2xl font-bold leading-tight group-hover:text-primary transition-colors">{ed.name}</h2>
                <p className="text-muted-foreground text-lg mt-1">{ed.year}</p>
                <p className="mt-4 inline-flex items-center text-sm font-medium text-primary">
                  Scopri di più →
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};
